import React from 'react';
import { ProductType, RegisterMode } from 'cart-model';
import Screen from '../ProductWizard/Screen';
import { IkeOrIkzeLimits } from './IkeOrIkze';
import { RetirementProductConfig } from './RetirementProductCard.types';
import IkeTaxBenefits from './IkeTaxBenefits';
import IkeDepositLimit from './IkeDepositLimit';
import IkzeTaxBenefits from './IkzeTaxBenefits';
import IkzeDepositLimit from './IkzeDepositLimit';

export const useRetirementProductConfigs = (): {
  ikeConfig: RetirementProductConfig;
  ikzeConfig: RetirementProductConfig;
} => {

  const ikeConfig: RetirementProductConfig = {
    productType: ProductType.ike,
    titleKey: 'ike.title',
    buttonLabelKey: 'ike.button_label',
    transferLabelKey: 'ike.transfer_label',
    transferButtonLabelKey: 'ike.transfer_button_label',
    transferRoute: Screen.TRANSFER_IKE.code,
    korpoLabelKey: 'ike.korpo_label',
    korpoButtonLabelKey: 'ike.korpo_button_label',
    korpoRoute: Screen.OPEN_IKE_KORPO.code,
    openRegisterMode: RegisterMode.OPEN,
    transferRegisterMode: RegisterMode.TRANSFER,
    korpoRegisterMode: RegisterMode.OPEN_KORPO,

    renderTaxBenefits: () => <IkeTaxBenefits />,

    renderDepositLimit: (limits: IkeOrIkzeLimits) => <IkeDepositLimit limits={limits} />
  };

  const ikzeConfig: RetirementProductConfig = {
    productType: ProductType.ikze,
    titleKey: 'ikze.title',
    buttonLabelKey: 'ikze.button_label',
    transferLabelKey: 'ikze.transfer_label',
    transferButtonLabelKey: 'ikze.transfer_button_label',
    transferRoute: Screen.TRANSFER_IKZE.code,
    korpoLabelKey: 'ikze.korpo_label',
    korpoButtonLabelKey: 'ikze.korpo_button_label',
    korpoRoute: Screen.OPEN_IKZE_KORPO.code,
    openRegisterMode: RegisterMode.OPEN,
    transferRegisterMode: RegisterMode.TRANSFER,
    korpoRegisterMode: RegisterMode.OPEN_KORPO,

    renderTaxBenefits: (limits?: IkeOrIkzeLimits) => <IkzeTaxBenefits limits={limits} />,

    renderDepositLimit: (limits: IkeOrIkzeLimits, onOpenDialog?: () => void) => (
      <IkzeDepositLimit limits={limits} onOpenDialog={onOpenDialog} />
    ),
  };

  return { ikeConfig, ikzeConfig };
};
